import { Waves } from 'lucide-react'

export function BrandMark() {
  return (
    <span className="brand-mark" aria-label="Aquatic Contractors">
      <span className="brand-mark__icon" aria-hidden="true"><Waves /></span>
      <span className="brand-mark__type">
        <strong>Aquatic</strong>
        <span>Contractors</span>
      </span>
    </span>
  )
}
